import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type Props = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

export default function GenerateRecoveryCodesDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => onClose(false)}>
      <DialogTitle>Generate two-factor authentication (2FA) recovery codes</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={styles.title}>
          Put these codes in a safe place.
        </Typography>
        <Typography variant="body2" paragraph>
          If you lose your device and don't have the recovery codes you will lose access to your account.
        </Typography>
        <Typography variant="body2">
          Generating new recovery codes will invalidate any existing unused codes. This does not change the keys
          used in authenticator apps. If you want to change the key used in an authenticator app, reset your
          authenticator key instead.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(true)} color="primary" variant="contained">
          Generate Recovery Codes
        </Button>
        <Button onClick={() => onClose(false)} color="inherit" variant="text">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  title: {
    fontWeight: 600,
    mb: 1
  }
};
